import React from 'react';

// export const PNG = () => {
//   return (
//     <svg
//       id="Layer_1"
//       data-name="Layer 1"
//       xmlns="http://www.w3.org/2000/svg"
//       viewBox="0 0 600 600"
//       width={24}
//       height={24}
//     >
//       <g id="Layer_1-2" data-name="Layer_1">
//         <g id="_388751432" data-name=" 388751432">
//           <path
//             id="_388752440"
//             data-name=" 388752440"
//             className="cls-2"
//             fill="#fff"
//             fillRule="evenodd"
//             d="M523.15,287.58c-3.42,0-6.18-2.76-6.18-6.18v-106.02L368.6,27.14H123.41c-22.36,0-40.51,18.15-40.51,40.51v213.75c0,3.42-2.76,6.18-6.18,6.18s-6.18-2.76-6.18-6.18V67.65c0-29.21,23.81-53,53-53h247.68c1.7,0,3.29.65,4.48,1.84l151.93,151.93c1.19,1.19,1.84,2.76,1.84,4.48v108.64c-.13,3.27-2.89,6.04-6.31,6.04h0ZM476.32,585.37H123.41c-29.21,0-53-23.81-53-53v-64.32c0-3.42,2.76-6.18,6.18-6.18s6.18,2.76,6.18,6.18v64.32c0,22.36,18.15,40.51,40.51,40.51h353.05c22.36,0,40.51-18.15,40.51-40.51v-64.32c0-3.42,2.76-6.18,6.18-6.18s6.18,2.76,6.18,6.18v64.32c.13,29.32-23.66,53-52.87,53h0Z"
//           />
//           <path
//             id="_388752416"
//             data-name=" 388752416"
//             className="cls-2"
//             fill="#fff"
//             fillRule="evenodd"
//             d="M523.15,178.92h-99.84c-32.1,0-58.26-26.18-58.26-58.26V20.81c0-3.42,2.76-6.18,6.18-6.18s6.18,2.76,6.18,6.18v99.84c0,25.25,20.52,45.91,45.91,45.91h99.84c3.42,0,6.18,2.76,6.18,6.18s-2.76,6.18-6.18,6.18h0Z"
//           />
//           <path
//             id="_388752032"
//             data-name=" 388752032"
//             className="cls-2"
//             fill="#fff"
//             fillRule="evenodd"
//             d="M579.05,506.58c-3.42,0-6.18-2.76-6.18-6.18v-184.42c0-15.65-12.62-28.29-28.29-28.29H55.28c-15.65,0-28.29,12.62-28.29,28.29v184.41c0,3.42-2.76,6.18-6.18,6.18s-6.18-2.76-6.18-6.18v-184.41c0-22.49,18.29-40.78,40.78-40.78h489.31c22.49,0,40.78,18.29,40.78,40.78v184.41c-.27,3.29-3.02,6.2-6.45,6.2h0Z"
//           />
//           <path
//             id="_388752632"
//             data-name=" 388752632"
//             className="cls-2"
//             fill="#fff"
//             fillRule="evenodd"
//             d="M546.96,538.68h-23.81c-3.42,0-6.18-2.76-6.18-6.18s2.76-6.18,6.18-6.18h23.81c14.34,0,25.92-11.57,25.92-25.92s-11.57-25.92-25.92-25.92H52.91c-14.34,0-25.92,11.57-25.92,25.92s11.57,25.92,25.92,25.92h23.81c3.42,0,6.18,2.76,6.18,6.18s-2.76,6.18-6.18,6.18h-23.81c-21.17,0-38.41-17.23-38.41-38.41s17.23-38.41,38.41-38.41h494.05c21.17,0,38.41,17.23,38.41,38.41-.13,21.17-17.37,38.41-38.41,38.41h0Z"
//           />
//           <path
//             id="_388752704"
//             data-name=" 388752704"
//             className="cls-2"
//             fill="#fff"
//             fillRule="evenodd"
//             d="M474.22,228.65H125.65c-3.42,0-6.18-2.76-6.18-6.18s2.76-6.18,6.18-6.18h348.57c3.42,0,6.18,2.76,6.18,6.18s-2.76,6.18-6.18,6.18h0Z"
//           />
//           <path
//             id="_388752368"
//             data-name=" 388752368"
//             className="cls-2"
//             fill="#fff"
//             fillRule="evenodd"
//             d="M329.39,165.37H125.65c-3.42,0-6.18-2.76-6.18-6.18s2.76-6.18,6.18-6.18h203.74c3.42,0,6.18,2.76,6.18,6.18.02,3.42-2.76,6.18-6.18,6.18h0Z"
//           />
//           <path
//             id="_388752176"
//             data-name=" 388752176"
//             className="cls-2"
//             fill="#fff"
//             fillRule="evenodd"
//             d="M329.39,102.1H125.65c-3.42,0-6.18-2.76-6.18-6.18s2.76-6.18,6.18-6.18h203.74c3.42,0,6.18,2.76,6.18,6.18.02,3.42-2.76,6.18-6.18,6.18h0Z"
//           />
//         </g>
//       </g>
//       <g>
//         <path
//           className="cls-1"
//           fill="#fff"
//           d="M154.53,390.66h-28.71v43.81c0,6.26-1.48,11.01-4.43,14.25-2.96,3.24-6.69,4.86-11.19,4.86s-8.52-1.6-11.4-4.8c-2.89-3.2-4.33-7.9-4.33-14.09v-119.29c0-6.9,1.58-11.82,4.75-14.78s8.2-4.43,15.1-4.43h40.22c11.89,0,21.04.92,27.45,2.74,6.33,1.76,11.8,4.68,16.41,8.76,4.61,4.08,8.11,9.08,10.5,14.99,2.39,5.91,3.59,12.56,3.59,19.95,0,15.77-4.86,27.71-14.57,35.84s-24.17,12.19-43.39,12.19ZM146.93,319.72h-21.11v47.29h21.11c7.39,0,13.56-.77,18.53-2.32,4.96-1.55,8.74-4.08,11.35-7.6,2.6-3.52,3.91-8.13,3.91-13.83,0-6.83-2.01-12.39-6.02-16.68-4.5-4.57-13.76-6.86-27.76-6.86Z"
//         />
//         <path
//           className="cls-1"
//           fill="#fff"
//           d="M262.22,312.33l60.28,91.21v-92.05c0-5.98,1.28-10.47,3.85-13.46,2.57-2.99,6.03-4.49,10.4-4.49s8.06,1.5,10.66,4.49c2.6,2.99,3.91,7.48,3.91,13.46v121.71c0,13.58-5.63,20.37-16.89,20.37-2.82,0-5.35-.41-7.6-1.21-2.25-.81-4.36-2.09-6.33-3.85-1.97-1.76-3.8-3.82-5.49-6.18-1.69-2.36-3.38-4.77-5.07-7.23l-58.8-90.15v90.68c0,5.91-1.37,10.38-4.12,13.41-2.74,3.02-6.26,4.54-10.56,4.54s-7.99-1.53-10.66-4.59c-2.68-3.06-4.01-7.51-4.01-13.35v-119.39c0-5.07.56-9.04,1.69-11.93,1.34-3.17,3.55-5.75,6.65-7.76,3.1-2.01,6.44-3.01,10.03-3.01,2.81,0,5.23.46,7.23,1.37,2.01.92,3.76,2.15,5.28,3.69,1.51,1.55,3.06,3.55,4.64,6.02,1.58,2.46,3.22,5.03,4.91,7.71Z"
//         />
//         <path
//           className="cls-1"
//           fill="#fff"
//           d="M509.67,388.02v29.66c0,3.94-.39,7.09-1.16,9.45-.78,2.36-2.2,4.49-4.28,6.39-2.08,1.9-4.73,3.73-7.97,5.49-9.36,5.07-18.37,8.76-27.02,11.08-8.66,2.32-18.09,3.48-28.29,3.48-11.89,0-22.73-1.83-32.51-5.49-9.78-3.66-18.12-8.97-25.02-15.94-6.9-6.97-12.19-15.41-15.89-25.33s-5.54-21.01-5.54-33.25,1.79-23.05,5.38-33.04c3.59-9.99,8.87-18.47,15.83-25.44,6.97-6.97,15.45-12.3,25.44-15.99,9.99-3.69,21.32-5.54,33.99-5.54,10.41,0,19.63,1.39,27.66,4.17,8.02,2.78,14.53,6.28,19.53,10.5,5,4.22,8.76,8.69,11.3,13.41,2.53,4.72,3.8,8.9,3.8,12.56,0,3.94-1.46,7.3-4.38,10.08-2.92,2.78-6.42,4.17-10.5,4.17-2.25,0-4.42-.53-6.49-1.58-2.08-1.06-3.82-2.53-5.23-4.43-3.87-6.05-7.14-10.63-9.82-13.72-2.68-3.1-6.28-5.7-10.82-7.81s-10.33-3.17-17.36-3.17-13.72,1.25-19.42,3.75c-5.7,2.5-10.57,6.12-14.62,10.87-4.05,4.75-7.14,10.57-9.29,17.47-2.15,6.9-3.22,14.53-3.22,22.91,0,18.16,4.17,32.13,12.51,41.91,8.34,9.78,19.97,14.67,34.89,14.67,7.25,0,14.06-.95,20.43-2.85,6.37-1.9,12.83-4.61,19.37-8.13v-25.12h-24.28c-5.84,0-10.26-.88-13.25-2.64-2.99-1.76-4.49-4.75-4.49-8.97,0-3.45,1.25-6.3,3.75-8.55,2.5-2.25,5.89-3.38,10.19-3.38h35.57c4.36,0,8.06.39,11.08,1.16,3.02.78,5.47,2.5,7.34,5.17,1.86,2.68,2.8,6.69,2.8,12.03Z"
//         />
//       </g>
//     </svg>
//   );
// };

export const PNG = () => {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 600 600"
      width={24}
      height={24}
    >
      {/* <!-- Generator: Adobe Illustrator 29.4.0, SVG Export Plug-In . SVG Version: 2.1.0 Build 152)  --> */}
      <g>
        <g>
          <path
            className="st0"
            fill="#fff"
            d="M377.22,344.18v51.39h36.87c7.34,0,14.05,3.5,17.22,9.01,3.17,5.5,2.23,12.04-2.4,16.77h-.05,0l-108.34,110.86c-3.63,3.7-9.06,5.85-14.81,5.85s-11.2-2.15-14.82-5.85l-108.34-110.86c-4.63-4.73-5.57-11.27-2.4-16.77s9.86-9.01,17.22-9.01h36.87v-51.39"
          />
          <path
            className="st0"
            fill="#fff"
            d="M232.11,105.4V33.1c0-8.74,8.53-15.83,19.07-15.83h104.82c10.55,0,19.07,7.09,19.07,15.83v72.31"
          />
        </g>
        <path
          className="st0"
          fill="#fff"
          d="M129.6,487.41v87.06c0,5.97,5.06,11.04,11.04,11.04h279.48c12.87,0,25.84.48,38.69,0,.18,0,.36,0,.54,0,5.97,0,11.04-5.06,11.04-11.04v-87.06c0-14.21-22.09-14.24-22.09,0v87.06c3.68-3.68,7.36-7.36,11.04-11.04H179.88c-12.77,0-25.95-.96-38.69,0-.18.01-.36,0-.54,0,3.68,3.68,7.36,7.36,11.04,11.04v-87.06c0-14.21-22.09-14.24-22.09,0h0Z"
        />
      </g>
      <g>
        <path
          className="st0"
          fill="#fff"
          d="M133.76,244.72h-32.35v54.57c0,7.81-1.66,13.72-4.99,17.75-3.33,4.03-7.53,6.05-12.61,6.05s-9.6-2-12.84-5.99c-3.26-3.99-4.87-9.84-4.87-17.55v-148.58c0-8.59,1.78-14.73,5.35-18.41,3.57-3.68,9.23-5.52,17.01-5.52h45.32c13.4,0,23.71,1.14,30.92,3.42,7.14,2.19,13.3,5.83,18.49,10.92,5.19,5.08,9.13,11.31,11.84,18.67,2.69,7.37,4.04,15.64,4.04,24.85,0,19.63-5.47,34.52-16.41,44.64-10.94,10.12-27.24,15.19-48.88,15.19ZM125.19,156.35h-23.78v58.9h23.78c8.33,0,15.28-.97,20.87-2.89,5.59-1.92,9.85-5.08,12.79-9.46,2.93-4.38,4.4-10.12,4.4-17.22,0-8.51-2.26-15.42-6.78-20.77-5.07-5.69-15.5-8.54-31.28-8.54h0Z"
        />
        <path
          className="st0"
          fill="#fff"
          d="M255.1,147.14l67.92,113.61v-114.66c0-7.45,1.45-13.04,4.34-16.77,2.89-3.72,6.8-5.59,11.71-5.59s9.08,1.86,12.01,5.59c2.93,3.72,4.4,9.32,4.4,16.77v151.62c0,16.92-6.34,25.38-19.03,25.38-3.18,0-6.02-.5-8.56-1.52-2.54-1-4.92-2.61-7.14-4.8-2.23-2.19-4.28-4.75-6.19-7.69-1.9-2.94-3.81-5.94-5.71-9.01l-66.25-112.3v112.96c0,7.37-1.55,12.93-4.64,16.7-3.09,3.77-7.06,5.66-11.89,5.66s-9-1.91-12.01-5.72c-3.01-3.82-4.52-9.35-4.52-16.64v-148.72c0-6.32.63-11.26,1.9-14.86,1.51-3.94,4.01-7.16,7.5-9.67,3.49-2.5,7.25-3.75,11.3-3.75,3.17,0,5.89.58,8.15,1.71,2.26,1.14,4.24,2.68,5.95,4.6,1.71,1.93,3.45,4.43,5.24,7.49,1.78,3.07,3.63,6.27,5.54,9.6h-.01Z"
        />
        <path
          className="st0"
          fill="#fff"
          d="M533.91,241.44v36.96c0,4.91-.43,8.84-1.31,11.76-.87,2.94-2.48,5.59-4.82,7.96s-5.34,4.65-8.98,6.84c-10.55,6.32-20.69,10.92-30.45,13.81-9.75,2.89-20.38,4.33-31.88,4.33-13.4,0-25.61-2.28-36.64-6.84-11.03-4.55-20.42-11.18-28.19-19.85-7.77-8.68-13.74-19.19-17.9-31.56-4.16-12.36-6.24-26.17-6.24-41.42s2.03-28.71,6.07-41.15c4.04-12.45,9.99-23.01,17.84-31.69,7.85-8.68,17.41-15.31,28.67-19.92,11.26-4.6,24.03-6.9,38.3-6.9,11.74,0,22.12,1.74,31.16,5.19,9.04,3.46,16.38,7.82,22,13.09,5.62,5.26,9.88,10.83,12.72,16.7,2.86,5.88,4.28,11.09,4.28,15.64,0,4.91-1.65,9.1-4.94,12.56s-7.24,5.19-11.84,5.19c-2.54,0-4.98-.66-7.32-1.97s-4.31-3.16-5.89-5.52c-4.36-7.54-8.05-13.23-11.06-17.09-3.01-3.86-7.08-7.1-12.19-9.73-5.12-2.63-11.64-3.94-19.56-3.94s-15.46,1.55-21.89,4.66c-6.42,3.11-11.91,7.63-16.48,13.54-4.56,5.91-8.05,13.17-10.46,21.76-2.42,8.59-3.63,18.1-3.63,28.53,0,22.62,4.69,40.02,14.1,52.21,9.4,12.19,22.5,18.28,39.31,18.28,8.17,0,15.83-1.19,23.02-3.55,7.17-2.36,14.45-5.74,21.82-10.12v-31.3h-27.36c-6.59,0-11.56-1.09-14.93-3.29-3.37-2.19-5.06-5.91-5.06-11.18,0-4.3,1.41-7.85,4.22-10.65,2.81-2.8,6.64-4.21,11.48-4.21h40.08c4.92,0,9.08.48,12.49,1.44,3.41.97,6.17,3.11,8.27,6.44,2.1,3.33,3.16,8.32,3.16,15h.03Z"
        />
      </g>
    </svg>
  );
};
